import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type PersonModel from 'tio-common/models/person';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedIdrDashboardIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const [loanSummary, person, allRecsQuery] = await Promise.all([
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      this.store.adapterFor('user').getLoanSummary(this.sessionContext.user.id),
      this.store.findRecord<PersonModel>(
        'person',
        // @ts-expect-error fix model
        this.sessionContext.user.person.id,
        {
          include: 'accounts.financial-institution,accounts.loans',
          reload: true,
        }
      ),
      this.store.query('recommendation', {
        filter: {
          user: this.sessionContext.user.id,
          'requesting-app': 'IDR',
        },
        include: 'user',
        sort: '-created-at',
        page: {
          offset: 0,
          limit: 3,
        },
      }),
    ]);

    // These are async: false relationships — data is already sideloaded via the include param
    const personAccounts = person.accounts;
    const user = person.user;

    return {
      accounts: personAccounts,
      allRecommendations: allRecsQuery,
      loanSummary: loanSummary,
      mostRecentRecommendation: allRecsQuery?.[0],
      person: person,
      user: user,
    };
  }
}
